module.exports = __webpack_public_path__ + "img/navRecapBanner2024-en.32fd8b11.svg";